import { useCallback, useMemo } from 'react'
import BedBankBookingCard from 'tripPlanner/components/Chat/BookingCards/BedBankBookingCard'
import ExperienceBookingCard from 'tripPlanner/components/Chat/BookingCards/ExperienceBookingCard'
import FlightBookingCard from 'tripPlanner/components/Chat/BookingCards/FlightBookingCard'
import HotelBookingCard from 'tripPlanner/components/Chat/BookingCards/HotelBookingCard'
import type { OfferTypeForTripItemTypes } from 'tripPlanner/hooks/api/common'
import { buildBookingScopedOrder, toSelectedBooking, type SelectableBooking, type SelectedBooking } from './addBookingsMessage'

interface Props {
  order: App.Order
  booking: SelectableBooking
  disabled: boolean
  onSelect: (selection: SelectedBooking, checked: boolean) => void
}

function AddBookingModalItem({ order, booking, disabled, onSelect }: Props) {
  const scopedOrder = useMemo(() => buildBookingScopedOrder(order, booking), [booking, order])

  const handleSelect = useCallback((_selectedOrder: App.Order, offers: Array<OfferTypeForTripItemTypes>, checked: boolean) => {
    onSelect(toSelectedBooking(order, booking, offers), checked)
  }, [booking, onSelect, order])

  switch (booking.bookingType) {
    case 'bedbank':
      return <BedBankBookingCard order={scopedOrder} bedbankOrderItem={booking.item} disabled={disabled} onSelect={handleSelect} />
    case 'hotel':
      return <HotelBookingCard order={scopedOrder} orderItem={booking.item} disabled={disabled} onSelect={handleSelect} />
    case 'flight':
      return <FlightBookingCard order={scopedOrder} orderFlightItem={booking.item} disabled={disabled} onSelect={handleSelect} />
    case 'experience':
      return <ExperienceBookingCard order={scopedOrder} experienceItem={booking.item} disabled={disabled} onSelect={handleSelect} />
  }
}

export default AddBookingModalItem
